import { Component, Prop, h, State, Host } from '@stencil/core';
import { WindowResizeService } from '../../services/window-resize-service';
import { ResponsiveNumber, ResponsiveString } from '../../typings';
export type ContentLineTagOptions = 'div' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'section' | 'article';
export type ContentLineTextAlignOptions = 'default' | 'left' | 'center' | 'right';
/**
 * @slot content - Inner contents of the line, usually plaintext.
 * @slot - Default slot, same as content slot.
 */
@Component({
  tag: 'content-line',
  styleUrl: 'content-line.scss',
  shadow: false,
})
export class ContentLine {
  /**
   * The element tag to use.
   * @type Select
   * @options div
   * @options p
   * @options h1
   * @options h2
   * @options h3
   * @options h4
   * @options h5
   * @options h6
   * @options span
   * @options section
   * @options article
   */
  @Prop() tag: ContentLineTagOptions = 'div';

  /**
   * Pipe separated list of ContentLineTextAlignOptions for text alignment.
   * @type Select
   * @options default
   * @options left
   * @options center
   * @options right
   * @responsive
   */
  @Prop() textAlign: ContentLineTextAlignOptions = 'default';

  /**
   * The font class for the line.
   * @type String
   * @responsive
   */
  @Prop() classes;
  @State() classString;

  /**
   * Pipe separated list of max width numbers. You can also use units such as "px" and "vw". If no unit is provided, defaults to percentage.
   * @type String
   * @responsive
   */
  @Prop() maxWidth: ResponsiveNumber = '100%';
  @State() inlineStyle: { [key: string]: string } = {};

  componentWillLoad() {
    WindowResizeService.registerProp(this.textAlign).subscribe(newValue => {
      this.inlineStyle = {
        ...this.inlineStyle,
        '--text-align': newValue as ContentLineTextAlignOptions,
      };
    });
    WindowResizeService.registerProp(this.maxWidth).subscribe((newValue: string | number) => {
      this.inlineStyle = {
        ...this.inlineStyle,
        '--max-width': isNaN(newValue as number) ? (newValue as string) : newValue + '%',
      };
    });
    WindowResizeService.registerProp(this.classes).subscribe(newValue => {
      this.classString = newValue as string;
    });
  }

  render() {
    // The capital case in this JSX variable is important
    const ElementTagParsed = `${this.tag}`;
    return (
      <Host class={this.classString} style={this.inlineStyle}>
        <ElementTagParsed class="content-line__inner">
          <slot name="content"></slot>
          <slot></slot>
        </ElementTagParsed>
      </Host>
    );
  }
}